// adapters/OpenLayersAdapter.ts
import { Map, View } from "ol";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import type { MapAdapter } from "../core/MapAdapter";
import "ol/ol.css";
import type { MapViewState } from "../types/MapTypes";
import { fromLonLat } from "ol/proj";
import type { MapLayer } from "../layers/types";

export class OpenLayersAdapter implements MapAdapter {
  private map?: Map;

  init(container: HTMLDivElement) {
    this.map = new Map({
      target: container,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
      ],
      view: new View({
        center: [0, 0],
        zoom: 2,
      }),
    });
  }

  setView(view: MapViewState) {
    this.map?.getView().setCenter(fromLonLat(view.center));
    this.map?.getView().setZoom(view.zoom);
  }

  setCenter(lng: number, lat: number, zoom = 5) {
    this.map?.getView().setCenter([lng, lat]);
    this.map?.getView().setZoom(zoom);
  }

  setBasemap(cfg: MapLayer | undefined) {}

  getView(): MapViewState {
    return {
      center: [0, 0],
      zoom: 0,
    };
  }

  getMapInstance() {
    return this.map;
  }

  destroy() {
    this.map?.setTarget(undefined);
  }

  resize() {
    this.map?.updateSize();
  }

  syncLayers(mapLayers: MapLayer[]): void {}
}
